import {Observable, Subscription} from 'rxjs';

import ILocalStorageStore from '../Interfaces/ILocalStorageStore';

const subscribeToEstimatedBandwidthWrite = (
    estimatedBandwidthWriteStream$: Observable<number>,
    localStorageStore: ILocalStorageStore
): Subscription =>
    estimatedBandwidthWriteStream$
        .subscribe(estimatedBandwidth => {
            localStorageStore.actions.write({estimatedBandwidth});
        });

export default subscribeToEstimatedBandwidthWrite;